/*
  s1111-site.js: the 11.11 pieces outside the sale page (marquee, product
  page strip, gift rows, bonus gift, set card, homepage deals, card badges).

  - Date copy: "main" (3–10 Nov), "d11" (11 Nov), "d12" (12 Nov), "over"
    (once the countdown reaches zero, Thu 12 Nov 23:59:59 SGT), SGT. Liquid
    renders the state when the page is built (snippets/s1111-state.liquid)
    and renders nothing at all from Fri 13 Nov 00:00; this file re-checks
    because pages can be served from cache, and switches without a reload.
    Elements with data-s1111-when="…" show only in the states they list;
    elements with data-s1111-end are removed once the sale is over, and the
    gold Subscribe & save card (.s11-sub) goes back to normal.
    ?s1111=main|d11|d12|over previews a state.
  - Countdown in every [data-s1111-clock]: days, hours, minutes, seconds to
    Thu 12 Nov 23:59:59 SGT, a fixed instant (the visitor's timezone doesn't
    matter), rounded down. Liquid prints the starting figures
    (snippets/s1111-left.liquid), so nothing moves when this runs.
  - Every tick works the time out again from the clock, so a late or
    skipped timer never drifts. Ticks land just after each second turns.
    Browsers slow timers in background tabs (to once a minute after a few
    minutes in Chrome) and freeze them (Android, Energy Saver, bfcache), so
    the clock is also re-checked as soon as the page is visible, resumed or
    shown again.
*/
(function () {
  'use strict';
  if (window.s1111SiteLoaded) return;
  window.s1111SiteLoaded = true;

  // Unix ms (UTC). Keep in step with snippets/s1111-state.liquid and s1111-left.liquid.
  var D11 = Date.UTC(2026, 10, 10, 16, 0, 0);       // Wed 11 Nov 00:00 SGT
  var D12 = Date.UTC(2026, 10, 11, 16, 0, 0);       // Thu 12 Nov 00:00 SGT
  var END = Date.UTC(2026, 10, 12, 15, 59, 59);     // Thu 12 Nov 23:59:59 SGT: zero, then "over"
  var STATES = ['main', 'd11', 'd12', 'over'];

  var forced = null;
  try {
    var q = new URLSearchParams(location.search).get('s1111');
    if (STATES.indexOf(q) > -1) forced = q;
  } catch (e) { /* old browser: no preview override */ }

  function currentState(now) {
    if (forced) return forced;
    if (now >= END) return 'over';
    if (now >= D12) return 'd12';
    if (now >= D11) return 'd11';
    return 'main';
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var state = null;
  var timer = null;

  function tick() {
    var now = Date.now();
    var next = currentState(now);
    if (next !== state) {
      state = next;
      if (state === 'over') {
        document.querySelectorAll('[data-s1111-end]').forEach(function (el) { el.remove(); });
        document.querySelectorAll('.s11-sub').forEach(function (el) { el.classList.remove('s11-sub'); });
      }
      document.querySelectorAll('[data-s1111-when]').forEach(function (el) {
        el.hidden = el.dataset.s1111When.split(' ').indexOf(state) === -1;
      });
    }
    var s = Math.max(0, Math.floor((END - now) / 1000));
    var parts = { d: String(Math.floor(s / 86400)), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
    document.querySelectorAll('[data-s1111-clock]').forEach(function (clock) {
      Object.keys(parts).forEach(function (k) {
        var el = clock.querySelector('[data-cd="' + k + '"]');
        if (el && el.textContent !== parts[k]) el.textContent = parts[k];
      });
    });
  }

  function loop() {
    clearTimeout(timer);
    tick();
    // END is on a whole second, so the clock turns when the wall clock does.
    timer = setTimeout(loop, 1000 - (Date.now() % 1000) + 15);
  }

  loop();
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') loop();
  });
  document.addEventListener('resume', loop);   // after the browser froze the tab
  window.addEventListener('pageshow', loop);
  window.addEventListener('focus', loop);
  document.addEventListener('shopify:section:load', function () {
    state = null;
    loop();
  });
})();
